import { render, staticRenderFns } from "./SchoolLeaveDetailTableControl.vue?vue&type=template&id=ded53c6e&scoped=true&"
import script from "./SchoolLeaveDetailTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveDetailTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded53c6e",
  null
  
)

export default component.exports